module.exports = __webpack_public_path__ + "assets/cd23075113c2688d89d0c0b8428be29b.png";